import { render } from "./VehicleGallerySlick.vue?vue&type=template&id=22a2ead2"
import script from "./VehicleGallerySlick.vue?vue&type=script&lang=js"
export * from "./VehicleGallerySlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/leaseitnow/VehicleGallerySlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22a2ead2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22a2ead2', __exports__)) {
    api.reload('22a2ead2', __exports__)
  }
  
  module.hot.accept("./VehicleGallerySlick.vue?vue&type=template&id=22a2ead2", () => {
    api.rerender('22a2ead2', render)
  })

}


export default __exports__